module.exports = __webpack_public_path__ + "static/media/parkingSpace.8f2bf136.svg";